import React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid';
import './styles.scss';

// Facilitadora
import julianaGuterres from '../../assets/images/facilitadores/juliana_guterres.png';

// Mentores
import alexMiranda from '../../assets/images/mentores/alex_miranda.png';
import angeloOzelame from '../../assets/images/mentores/angelo_ozelame.png';
import brunoHaas from '../../assets/images/mentores/bruno_haas.png';
import felipe from '../../assets/images/mentores/felipe_fs.png';
import lucasSantos from '../../assets/images/mentores/lucas_santos.png';
import renatoCandido from '../../assets/images/mentores/renato_candido.png';
import rodrigoPaiva from '../../assets/images/mentores/rodrigo_paiva.png';
import sandroPinheiro from '../../assets/images/mentores/sandro_pinheiro.png';

const Mentor = ({ imgSrc, bio, name }) => (
  <div>
    <div className="mentor">
      <img alt={name} src={imgSrc} />
      <p className="mentor-bio">{bio}</p>
    </div>
    <p className="mentor-name">{name}</p>
  </div>
);

const Mentores = () => (
  <Grid>
    <Row>
      <Col xs>
        <header className="major">
          <h2 style={{ marginBottom: -5 }}>Facilitadora</h2>
        </header>
      </Col>
    </Row>
    <Row>
      <Col xs>
        <Mentor
          bio="Fã das gentes e das conexões.
          Participa de grupos de associativismo, organiza eventos de fomento ao empreendedorismo e inovação e lidera várias frentes na Comunidade RS.
          Atual Diretora de Ecossistema da AGS - Associação Gaucha de Startups e Líder de Comunidade do Inovativa Brasil no RS."
          imgSrc={julianaGuterres}
          name="Juliana Guterres"
        />
      </Col>
    </Row>
    <Row>
      <Col xs>
        <header className="major">
          <h2 style={{ marginBottom: -5 }}>Mentores</h2>
        </header>
      </Col>
    </Row>
    <Row center="xs">
      <Col xs>
        <Mentor
          bio="CEO da Plantae.
          Grande entusiasta por tecnologia e inovação.
          Desenvolvedor e arquiteto de software, autodidata, com excelentes conhecimentos em ferramentas de análise e desenvolvimento, bom comunicador e dotado de iniciativa."
          imgSrc={alexMiranda}
          name="Alex Miranda"
        />
      </Col>
      <Col xs>
        <Mentor
          bio="Engenheiro agrônomo formado pela FAEM/UFPel.
          MBA em engenharia de produção e inovação pela UFRGS.
          Atuou como gestor técnico do IMEA (Instituto Mato-grossense de Economia Agropecuária). E co-fundador da Escola Agro."
          imgSrc={angeloOzelame}
          name="Ângelo Ozelame"
        />
      </Col>
      <Col xs>
        <Mentor
          bio="Economista especialista em gestão de projetos.
          Experiência em estratégia e inteligência de negócios.
          Coordenador da incubadora de startups da Universidade La Salle."
          imgSrc={brunoHaas}
          name="Bruno Hass"
        />
      </Col>
      <Col xs>
        <Mentor
          bio="Full Stack Developer.
          Assesor de Projetos no GPSATi.
          Entusiasta de criptoativos, libertário e adepto à escola Áustriaca de Econômia."
          imgSrc={felipe}
          name="Felipe Faé Schwade"
        />
      </Col>
      <Col xs>
        <Mentor
          bio="Engenheiro Agrícola e Ambiental pela UFMT.
          Atualmente é engenheiro em agricultura digital no grupo MVR AGRO,
          atua com tecnologias de telemetria de máquinas agrícolas,
          análise de dados para MIP e cientista de dados júnior para agricultura.
          É escritor para a revista Campo e Negócios e a revista internacional PrecisionAG."
          imgSrc={lucasSantos}
          name="Lucas dos Santos Corrêa"
        />
      </Col>
      <Col xs>
        <Mentor
          bio="Possui graduação em Química Industrial pelo Instituto Municipal de Ensino Superior de Assis (IMESA),
          especilista em Química pela UFLA e especialista em Manejo do Solos pela Esalq-USP.
          Atualmente é responsável técnico do laboratório Solos & Plantas.
          Tem experiência na área de análises agronômicas, análise e ensino de química."
          imgSrc={renatoCandido}
          name="Renato Cândido"
        />
      </Col>
      <Col xs>
        <Mentor
          bio="Co-fundador e CTO da QuantoSobra, com mais de 10 anos de experiência em gestão de equipes e desenvolvimento de software.
          Atualmente também é presidente da ATIvales, Associação das Empresas de Tecnologia e Inovação dos Vales do Rio Pardo e Taquari."
          imgSrc="https://www.quantosobra.com.br/wp-content/uploads/2019/07/IMG_8889-2-400x400.jpg"
          name="Ricardo Severo"
        />
      </Col>
      <Col xs>
        <Mentor
          bio="Full Stack e Mobile Developer.
          Professor na Faculdade FASIPE, fundador da W2R Soluções, fundador e CPO no WebPago.
          Membro do HubNorte, ajudando a fortalecer o ecossistema de empreendedorismo no norte do Mato Grosso."
          imgSrc={rodrigoPaiva}
          name="Rodrigo Paiva"
        />
      </Col>
      <Col xs>
        <Mentor
          bio="Graduado em Administração pela URI Erechim.
          MBA Executivo em Negócios Financeiros pela Escola de Negócios da PUC/RJ,
          mestrando do curso de economia da UFRGS.
          Diretor Financeiro do Grupo Guimarães com atuação na produção agrícola e concessionárias de máquinas agrícola."
          imgSrc={sandroPinheiro}
          name="Sandro Pinheiro"
        />
      </Col>
    </Row>
  </Grid>
);

export default Mentores;
